import { render, staticRenderFns } from "./add - 副本.vue?vue&type=template&id=752dc126&scoped=true"
import script from "./add - 副本.vue?vue&type=script&lang=js"
export * from "./add - 副本.vue?vue&type=script&lang=js"
import style0 from "./add - 副本.vue?vue&type=style&index=0&id=752dc126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752dc126",
  null
  
)

export default component.exports